// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17f92","left":"styles_left__200Oj"};